export default "__VITE_ASSET__Bk4ebfn7__"